import React from 'react';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import styles from './Notification.module.scss';

class Notification {
  static success(text, icon) {
    this.show(text, 'success', icon);
  }

  static error(data, icon) {
    this.show(data, 'error', icon);
  }

  static warning(data, icon) {
    this.show(data, 'warning', icon);
  }

  static show(text, type, icon) {
    toast(this.render(text, icon), {
      hideProgressBar: true,
      position: 'top-center',
      className: `${styles.notification} ${type}`,
      closeOnClick: false,
    });
  }

  static render(text, icon) {
    let displayText = text;

    if (typeof text !== 'string') {
      if (text?.message) {
        displayText = text.message;
      } else if (text?.error) {
        displayText = text.error;
      } else {
        displayText = JSON.stringify(text);
      }
    }

    return (
      <div className={styles.notificationText}>
        {icon && <img src={icon} alt="notify-icon" />}
        {displayText}
      </div>
    );
  }
}

export default Notification;
